import { render, staticRenderFns } from "./NRS.vue?vue&type=template&id=a2337422&"
import script from "./NRS.vue?vue&type=script&lang=js&"
export * from "./NRS.vue?vue&type=script&lang=js&"
import style0 from "./NRS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports